import { cn } from '../../lib/utils';
import { Progress } from '../ui/progress';

export const ScoreDisplay = ({ 
    scores, 
    type = 'communication', // communication, voice, overall
    showDetails = true,
    className 
}) => {
    const getScoreColor = (score) => {
        if (score >= 80) return 'text-emerald-500';
        if (score >= 60) return 'text-yellow-500';
        return 'text-red-500';
    };

    const getProgressColor = (score) => {
        if (score >= 80) return 'bg-emerald-500';
        if (score >= 60) return 'bg-yellow-500';
        return 'bg-red-500';
    };

    const communicationLabels = {
        understanding: 'Understanding',
        communication: 'Communication',
        confidence: 'Confidence',
        professionalism: 'Professionalism',
        completeness: 'Completeness',
    };

    const voiceLabels = {
        clarity: 'Clarity',
        confidence: 'Confidence',
        fluency: 'Fluency',
        pronunciation: 'Pronunciation',
        pace: 'Pace',
        professional_tone: 'Professional Tone',
    };

    const labels = type === 'voice' ? voiceLabels : communicationLabels;
    const overall = scores?.overall || 0;

    return (
        <div className={cn('space-y-4', className)}>
            {/* Overall Score */}
            <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
                <span className="text-sm font-medium text-muted-foreground">Overall Score</span>
                <span className={cn('text-3xl font-bold font-heading', getScoreColor(overall))}>
                    {overall}
                </span>
            </div>

            {/* Detailed Scores */}
            {showDetails && (
                <div className="space-y-3">
                    {Object.entries(labels).map(([key, label]) => {
                        const score = scores?.[key] || 0;
                        return (
                            <div key={key} className="space-y-1">
                                <div className="flex items-center justify-between text-sm">
                                    <span className="text-muted-foreground">{label}</span>
                                    <span className={cn('font-medium', getScoreColor(score))}>
                                        {score}
                                    </span>
                                </div>
                                <div className="h-2 bg-muted rounded-full overflow-hidden">
                                    <div 
                                        className={cn('h-full rounded-full transition-all duration-500', getProgressColor(score))}
                                        style={{ width: `${score}%` }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Feedback */}
            {scores?.feedback && (
                <div className="p-4 rounded-xl bg-primary/5 border border-primary/20">
                    <p className="text-sm text-muted-foreground">{scores.feedback}</p>
                </div>
            )}

            {/* Improvement Tips */}
            {scores?.improvement_tips?.length > 0 && (
                <div className="space-y-2">
                    <h4 className="text-sm font-medium">Improvement Tips:</h4>
                    <ul className="space-y-1">
                        {scores.improvement_tips.map((tip, i) => (
                            <li key={i} className="text-sm text-muted-foreground flex items-start gap-2">
                                <span className="text-primary">•</span>
                                {tip}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
